import React from "react";
import ReactSelect from "react-select";

function select({
  defaultValue,
  value,
  options,
  isClearable,
  isCleareble,
  ...otherProps
}) {
  const clearable = isClearable ?? isCleareble

  const safeOptions = Array.isArray(options) ? options : []

  // Construct value
  let valueObject = null

  if (Array.isArray(value)) {
    valueObject = value.map(value => { 
      const option = safeOptions.find(o => o.value === value)
      return option ? { value: value, label: option.label } : null
    })
  } else if (value) {
    const option = safeOptions.find(o => o.value === value)
    valueObject = {
      value: value,
      label: (option ?? {}).label,
    }
  }

  return (
    <ReactSelect
      isMulti={!!otherProps.isMulti}
      defaultValue={
        defaultValue && {
          value: defaultValue,
          label: (safeOptions.find(o => o.value === defaultValue) ?? {}).label,
        }
      }
      menuPosition="fixed"
      value={valueObject}
      options={safeOptions}
      isClearable={!!clearable}
      {...otherProps}
    />
  );
}

export default select;
